module.exports = __webpack_public_path__ + "img/black02_128.fe23b954.png";